import {
  FETCH_UNLOCK_HOMEWORK_SUCCESS,
} from './actions';
import UnlockHomework from './model';
import { Map } from 'immutable';

export default function unlockHomework(state = new Map({ unlockable: false }), action) {
  switch (action.type) {
    case FETCH_UNLOCK_HOMEWORK_SUCCESS:
      return state.set(action.groupId, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(response) {
  return response.reduce((map, unlock) => map.set(`${unlock.studentId}`,
      UnlockHomework.crete(unlock)), new Map());
}



// WEBPACK FOOTER //
// ./data/UnlockHomework/reducer.js